import { useFetch } from '../../hooks/useFetch';
import {
	AccordionBlockData,
	ExpandedAccordionBlock,
} from '../../types/optimizely/blocks/accordionBlock';

export const useAccordionBlockData = (
	blockId: string,
): AccordionBlockData | null => {
	const { data } = useFetch<ExpandedAccordionBlock>(blockId);
	if (data) {
		return {
			title: data?.title.value,
			backgroundColor: data.backgroundColor.value,
			fontColor: data.fontColor.value,
			items:
				data.features?.expandedValue?.map(
					({ image, text, title, showTitle, useImageAsHorizontal }) => ({
						description: text?.value,
						title: title.value,
						imageUrl: image.value?.url,
						showTitle: showTitle.value,
						useImageAsHorizontal: useImageAsHorizontal.value
					}),
				) ?? [],
		};
	} else {
		return null;
	}
};
